import React from 'react';

const Thumbnail = () => (
  <div className="w-full h-20 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-2 flex flex-col justify-center gap-1 px-3">
    <div className="w-full h-1.5 bg-zinc-200 dark:bg-zinc-700 rounded" />
    <div className="w-full h-1.5 bg-zinc-200 dark:bg-zinc-700 rounded" />
    <div className="w-3/4 h-1.5 bg-zinc-200 dark:bg-zinc-700 rounded" />
  </div>
);

export default Thumbnail;
